import { Box, Card, CardBody, CardHeader, FormLabel } from '@chakra-ui/react';
import CheckboxSelect from 'components/ui/CheckboxSelect/CheckboxSelect';
//import { toDate } from 'date-fns';
import { toDate } from 'date-fns-tz';
import { useMemo, useState } from 'react';
import { Chart } from 'react-google-charts';
import { useFormContext } from 'react-hook-form';
import { useAnalyticsMetricsByDay } from '../hooks/useAnalyticsMetricsByDay';

//const metrics = ['Envios', 'Entregas', 'Aberturas', 'Cliques', 'Complaints', 'Transient Bounces', 'Permanent Bounces'];
//const colors = ['#004A77', '#78A22F', '#FF9E00', '#904287', '#008F87', '#595959', '#ECD6EA'];

const metrics = ['Send', 'Delivery', 'Open', 'Click', 'Complaint', 'Bounce'];
const labels = [
  'Envios',
  'Entregas',
  'Aberturas',
  'Cliques',
  'Reclamações',
  'Devoluções',
];
const colors = [
  '#004A77',
  '#78A22F',
  '#FF9E00',
  '#904287',
  '#008F87',
  '#595959',
];

const metricOptions = metrics.map((value, i) => ({
  value: i,
  label: labels[i],
}));

// const metricList = {
//   send: {
//     label: 'Envios',
//     color: '#004A77'
//   },
//   delivery: {
//     label: 'Entregas',
//     color: '#78A22F'
//   },
//   open: {
//     label: 'Aberturas',
//     color: '#FF9E00'
//   },
//   click: {
//     label: 'Cliques',
//     color: '#904287'
//   },
//   complaints: {
//     label: 'Complaints',
//     color: '#008F87'
//   },
//   softBounce: {
//     label: 'Transient Bounces',
//     color: '#595959'
//   },
//   hardBounce: {
//     label: 'Permanent Bounces',
//     color: '#ECD6EA'
//   }
// };

const options = {
  //title: '',
  curveType: 'function',
  // animation: {
  //   duration: 1000,
  //   easing: "out",
  // },
  chartArea: {
    top: 25,
    width: '85%',
    height: '80%',
  },
  legend: {
    position: 'bottom',
  },
  fontSize: 13,
  fontName: 'Inter, sans-serif',
  // chart: {
  //   title: '',
  //   subtitle: '',
  // },

  hAxis: {
    //title: 'Dias',
    //format: 'dd/MM/yyyy',
    //minValue: 0
    //maxValue: 10000
    gridlines: {
      //count: 10,
      units: {
        years: { format: 'YYYY' },
        months: { format: 'MMM/YYYY' },
        days: { format: 'dd/MM/YYYY' },
      },
    },
    minorGridlines: {
      units: {
        months: { format: 'MMM' },
        days: { format: 'dd/MMM' },
        hours: { format: '' },
        minutes: { format: '' },
      },
    },
  },
  vAxis: {
    title: 'Volume',
    //scaleType: 'log',
    //minValue: 0,
    //maxValue: 1000,
    //scaleType: 'mirrorLog'
    //gridlines: { color: 'none' },
    viewWindow: {
      min: 0,
    },
  },
  //colors: ['#004A77', '#78A22F', '#FF9E00', '#904287',  '#008F87', '#595959', '#ECD6EA', '#FFECCC', '#E5F1D0', '#B1E1FF']
};

export default function MetricsChart() {
  const { watch } = useFormContext();
  const [company, dateRange, lists, emailCategory, contentGroups] = watch([
    'company',
    'dateRange',
    'lists',
    'emailCategory',
    'contentGroups',
  ]);

  const params: Record<string, unknown> = { dateRange };

  if (company) {
    params.companyId = company.value;
  }

  if (lists) {
    params.listIds = lists.map((l) => l.value);
  }

  if (emailCategory) {
    params.emailCategory = emailCategory.value;
  }

  if (contentGroups) {
    params.contentGroupIds = contentGroups.map((c) => c.value);
  }

  const { data } = useAnalyticsMetricsByDay(params);

  const [selectedMetricOptions, setSelectedMetricOptions] =
    useState(metricOptions);

  const selectedMetricIndexes = useMemo(
    () => selectedMetricOptions.map((m) => m.value),
    [selectedMetricOptions]
  );

  const metrics = useMemo(() => {
    if (data) {
      return [
        [
          { type: 'date', label: 'Dias' },
          ...labels.filter((v, i) => selectedMetricIndexes.includes(i)),
        ],
        ...Object.entries(data).map(([k, v]) => [
          toDate(`${k} 03:00:00`),
          ...Object.values(v).filter((v, i) =>
            selectedMetricIndexes.includes(i)
          ),
        ]),
      ];
    }
    return null;
  }, [data, selectedMetricIndexes]);

  return (
    <Card variant="stat" size="sm" mt="50px">
      <CardHeader>
        <Box maxW="350px">
          <FormLabel>Selecione as métricas que deseja visualizar</FormLabel>
          <CheckboxSelect
            placeholder="Todos as métricas"
            options={metricOptions}
            isMulti
            value={selectedMetricOptions}
            onChange={(value: any) => setSelectedMetricOptions(value)}
            isClearable={false}
            blurInputOnSelect={false}
          />
        </Box>
      </CardHeader>
      <CardBody minH="500px">
        {metrics && (
          <Chart
            chartType="LineChart"
            chartLanguage="pt-BR"
            width="100%"
            height="500px"
            data={metrics}
            options={{
              ...options,
              colors: colors.filter((c, i) =>
                selectedMetricIndexes.includes(i)
              ),
            }}
          />
        )}
      </CardBody>
    </Card>
  );
}
